import { Filter } from "filter";
import { useEffect, useState } from "react";
import ItemCodeSearch from "./itemCodeSearch";
import { CommonUtilities } from "commonUtils";
import TransactionServices from "../TransactionServices";
import SearchTerritory from "components/User Profile/Client Profiles/ClientProfilePortal/search_Territory";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import DatePickerRange from "components/PeriodSelection/DatePickerRange";
import SearchCurrency from "../searchCurrency";

export default function InvoiceManualInput(param: any) {

    let [periodList, setPeriodList] = useState<any>([]);
    let [totalFactSale, settotalFactSale] = useState(0);
    let [manuelInput, setManuelInput] = useState<any>([]);
    let [ItemCodeOpen, setItemCodeOpen] = useState(false);
    let [openTerritory, setopenTerritory] = useState(false);
    let [custTplCommit, setcustTplCommit] = useState(false);
    let [fieldsInvalid, setfieldsInvalid] = useState(false);
    let [invoiceSelect, setInvoiceSelect] = useState<any>([]);
    let [invalidHomeValue, SetinvalidHomeValue] = useState(false);
    let [invalidRUnitsSold, SetinvalidUnitsSold] = useState(false);
    let [invalidDealerPrice, SetinvalidDealerPrice] = useState(false);
    let [invalidRetailPrice, SetinvalidRetailPrice] = useState(false);
    let [factSaleDeleteFlag, setfactSaleDeleteFlag] = useState(false);
    let [factSaleActSuccess, setfactSaleActSuccess] = useState(false);
    let [analysisCodesList, setAnalysisCodesList] = useState<any>([]);
    let [systemFormatsList, setSystemFormatsList] = useState<any>([]);
    let [territoryCodeList, setTerritoryCodeList] = useState<any>([]);
    let [impHolStreamDetailCount, setimpHolStreamDetailCount] = useState(0);
    let [loadCustomMetadataMain, setloadCustomMetadataMain] = useState(false);
    let [impHolStreamDetailData, setImpHolStreamDetailData] = useState<any>([]);

    useEffect(() => {
        console.log(param)
        if (param?.invoiceSelect) {
            setInvoiceSelect({ ...param.invoiceSelect });
        }

        //invoiceSelect?.approvalStatus
        TransactionServices.periodCount({}).then((respond: any) => setPeriodList(respond))
        TransactionServices.territoryCode({}).then((respond: any) => setTerritoryCodeList(respond))
        TransactionServices.contractsanalysisCodes().then((respond: any) => setAnalysisCodesList(respond))
        TransactionServices.contractssystemFormats({}).then((respond: any) => setSystemFormatsList(respond))

    }, [param?.invoiceSelect]);

    const factSalesActSave = () => {

        if (validateField()) {
            TransactionServices.saveDetails(manuelInput)
        }
    }

    const clearFactSales = () => {
        manuelInput = {}
        setManuelInput(manuelInput)
    }

    const onInvoiceEdit = (e: any) => {
        manuelInput = e
        setManuelInput(manuelInput)

        console.log(e?.mtchTerritoryCode)
        console.log(territoryCodeList)

        var terr_name = ''
        var currency_Value = 0

        if (e?.mtchTerritoryCode) {
            var territoryCodeFilter = territoryCodeList?.filter((ter: any) => ter.territoryCode?.toLowerCase() === e?.mtchTerritoryCode?.toLowerCase())[0]
            console.log(territoryCodeFilter)
            terr_name = territoryCodeFilter?.territoryName
        }
        if (e?.monetaryValue && !e?.currencyValue) {
            currency_Value = e.monetaryValue;
        }

        setManuelInput({ ...manuelInput, mtchTerritoryName: terr_name, currencyValue: currency_Value });
    }

    const invoiceApprove = () => {
        if (!loadCustomMetadataMain) {
            loadCustomMetadataMain = true
            setloadCustomMetadataMain(loadCustomMetadataMain)

            TransactionServices.loadfactSalesActsCAA(invoiceSelect?.headerType, '', '', invoiceSelect?.accountCode, invoiceSelect?.invoiceNum, 0, 0, 1, 10, '').then((respond: any) => {

                impHolStreamDetailData = respond
                setImpHolStreamDetailData(impHolStreamDetailData)
                impHolStreamDetailCount = impHolStreamDetailData[0] && impHolStreamDetailData[0]?.totalRows
                setimpHolStreamDetailCount(impHolStreamDetailCount)

                totalFactSale = respond[0] && respond[0]?.sumMonetaryValue
                settotalFactSale(totalFactSale);
            })
        } else {
            loadCustomMetadataMain = false
            setloadCustomMetadataMain(loadCustomMetadataMain)
        }
    }

    const ItemCodeCOpen = (e: any) => {
        ItemCodeOpen = true;
        setItemCodeOpen(ItemCodeOpen)
    }

    const ItemCodeClose = (e: any) => {
        console.log(e)
        console.log(e?.data)

        if (e?.data) {
            var code = e?.data?.intStdRecCode ?? e?.data?.catLogNumber ?? e?.data?.contractRefNum
            setManuelInput({ ...manuelInput, itemCodeSold: code })
        }

        ItemCodeOpen = false;
        setItemCodeOpen(ItemCodeOpen)
    }

    const validateField = () => {
        var validateField_sts = false;

        const homeSign_field: any = document.getElementById("homeSign");
        const unitsSold_field: any = document.getElementById("unitsSold");
        const salesDate_field: any = document.getElementById("salesDate");
        const dealerPrice_field: any = document.getElementById("dealerPrice");
        const retailPrice_field: any = document.getElementById("retailPrice");
        const itemCodeSold_field: any = document.getElementById("itemCodeSold");
        const currencySign_field: any = document.getElementById("currencySign");
        const monetaryValue_field: any = document.getElementById("monetaryValue");
        const currencyValue_field: any = document.getElementById("currencyValue");
        const mtchFormatCode_field: any = document.getElementById("mtchFormatCode");
        const mtchAnalysisCode_field: any = document.getElementById("mtchAnalysisCode");
        const mtchTerritoryCode_field: any = document.getElementById("mtchTerritoryName");

        if (!manuelInput?.homeSign) { homeSign_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.unitsSold) { unitsSold_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.salesDate) { salesDate_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.dealerPrice) { dealerPrice_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.retailPrice) { retailPrice_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.itemCodeSold) { itemCodeSold_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.currencySign) { currencySign_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.monetaryValue) { monetaryValue_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.currencyValue) { currencyValue_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.mtchFormatCode) { mtchFormatCode_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.mtchAnalysisCode) { mtchAnalysisCode_field.style.border = "1px solid #e50e0e"; }
        if (!manuelInput?.mtchTerritoryCode) { mtchTerritoryCode_field.style.border = "1px solid #e50e0e"; }


        if (!validateField_sts) {
            CommonUtilities.showToastDawer('There was a problem submitting your request, one or more fields are missing or incorrect', 'fail')
        }

        setTimeout(() => {
            homeSign_field.style.border = "1px solid 1px solid #dedede";
            unitsSold_field.style.border = "1px solid 1px solid #dedede";
            salesDate_field.style.border = "1px solid 1px solid #dedede";
            dealerPrice_field.style.border = "1px solid 1px solid #dedede";
            retailPrice_field.style.border = "1px solid 1px solid #dedede";
            itemCodeSold_field.style.border = "1px solid 1px solid #dedede";
            currencySign_field.style.border = "1px solid 1px solid #dedede";
            monetaryValue_field.style.border = "1px solid 1px solid #dedede";
            currencyValue_field.style.border = "1px solid 1px solid #dedede";
            mtchFormatCode_field.style.border = "1px solid 1px solid #dedede";
            mtchAnalysisCode_field.style.border = "1px solid 1px solid #dedede";
            mtchTerritoryCode_field.style.border = "1px solid 1px solid #dedede";
        }, 2000);

        return validateField_sts
    }

    const closeTerritoryDetail = (e: any) => { }
    const onCustTplCommit = () => { }

    const onSelectTerritory = (e: any) => {
        console.log(e)
        openTerritory = false;
        setopenTerritory(openTerritory)
        setManuelInput({ ...manuelInput, mtchTerritoryCode: e.territoryCode, mtchTerritoryName: e.territoryName })
    }


    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);

    const onInvoiceDelete = (e: any) => {
        deleteData = e;
        setDeleteData(deleteData)

        deleteStatus = true;
        setDeleteStatus(deleteStatus)
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(deleteData)
        if (e == 1) {
            TransactionServices.deleteFactSalesAct(deleteData)
        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    const dateSelection = (e: any) => {
        console.log(e)

        setManuelInput({ ...manuelInput, salesDate: Filter?.DateTimeFormatNumberSeparate(e) })
        console.log(Filter?.DateTimeFormatNumberSeparate(e))
    }

    const [currency, setcurrency] = useState(false);
    const Closecurrency = (value: any) => {
        console.log(value);
        setcurrency(false);
        setManuelInput({ ...manuelInput, currencySign: value.territoryCurrency })
    }

    let [approvedStatus, setApprovedStatus] = useState(false);
    const approvedConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(deleteData)
        if (e == 1) {
            console.log(invoiceSelect)
            var payload = {
                accountCode: invoiceSelect?.accountCode, approvalStatus: invoiceSelect?.approvalStatus,
                comments: invoiceSelect?.comments, currencySign: invoiceSelect?.currencySign,
                currencyValue: invoiceSelect?.currencyValue, exchRate1: invoiceSelect?.exchRate1,
                hasData: invoiceSelect?.hasData, headerType: invoiceSelect?.headerType,
                homeSign: invoiceSelect?.homeSign, homeValue: invoiceSelect?.homeValue,
                invDescription: invoiceSelect?.invDescription, invId: invoiceSelect?.invId,
                invoiceDate: invoiceSelect?.invoiceDate, invoiceNum: invoiceSelect?.invoiceNum,
                isApproved: !invoiceSelect?.isApproved, royaltyPeriod: invoiceSelect?.royaltyPeriod,
                setRelease: invoiceSelect?.setRelease, transactionRef: invoiceSelect?.transactionRef,
            }

            TransactionServices.invoice_save(payload)
        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    } 

    return (
        <>
            <div className="ws-12 slide">

                {!invoiceSelect?.approvalStatus && <div className="ws-12 box borderRounded">
                    <div className="box-header well">
                        <h2 >Fact Sales Entry</h2>
                    </div>

                    <div className="box-content">
                        {fieldsInvalid && <div className="alert alert-danger">There was a problem submitting your request, one or more fields are missing or incorrect. </div>}

                        <div className="ws-12">
                            <div className="ws-6">

                                <div className="form-format" title="Release, Track or Contract ID">
                                    <label className="control-label ">Item Code*</label>
                                    <div className="label-entries ws-12">
                                        <button type="button" className="btn noCursor infoText icon-btn primary noTransition " onClick={ItemCodeCOpen}>Choose a code</button>
                                        <div className="ws-8">
                                            <input type="text" placeholder="Enter Item Code" className="ws-12" readOnly name="itemCodeSold" value={manuelInput?.itemCodeSold ?? ""}
                                                onChange={(e: any) => setManuelInput({ ...manuelInput, itemCodeSold: e.target.value })} id="itemCodeSold" required />
                                        </div>

                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="ws-12">Analysis Code*</label>
                                    <div className="label-entries ws-12">
                                        <button type="button" className="btn noCursor infoText icon-btn info noTransition ">{manuelInput?.mtchAnalysisCode ?? "Analysis Code"}</button>
                                        <div className="ws-8 noTransition">
                                            <select className="noTransition" value={manuelInput?.mtchAnalysisCode ?? ""}
                                                onChange={(e: any) => setManuelInput({ ...manuelInput, mtchAnalysisCode: e.target.value })} name="mtchAnalysisCode" id="mtchAnalysisCode" required>
                                                <option value="" >Choose Analysis Code</option>
                                                {
                                                    analysisCodesList?.map((values: any) => {
                                                        return (
                                                            <option
                                                                key={values?.analysisCode}
                                                                value={values?.analysisCode}
                                                                label={`${values?.analysisCode} - ${values?.analysisText ?? ""}`}
                                                            >
                                                                {`${values?.analysisCode} - ${values?.analysisText ?? ""}`}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>

                                        </div>
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label ">Line Description*</label>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Enter Line Description" value={manuelInput?.lineDescription ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, lineDescription: e.target.value })} name="lineDescription" id="lineDescription" required />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label ">Territory*</label>
                                    <div className="label-entries ws-12">
                                        <button type="button" className="btn noCursor infoText icon-btn info " onClick={() => setopenTerritory(true)}>
                                            {manuelInput?.mtchTerritoryCode ?? "Territory Code"}
                                        </button>
                                        <div className="ws-8">
                                            <input type="text" placeholder="Enter a Territory" value={manuelInput?.mtchTerritoryName ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, mtchTerritoryName: e.target.value })} id="mtchTerritoryCode" name="mtchTerritoryCode" readOnly required />

                                        </div>
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label ">Invoice Date*</label>
                                    <div className="label-entries hide">
                                        <input type="text" placeholder=" Select Invoice Date" name="salesDate" onChange={(e: any) => setManuelInput({ ...manuelInput, salesDate: e.target.value })} id="salesDate" readOnly required />
                                    </div>

                                    <div className="w-90">
                                        <DatePickerRange onChange={dateSelection} name={""} type={"single"} data={manuelInput?.salesDate ?? ""} id="invoiceDate" />
                                    </div>

                                </div>

                                {periodList?.lenght != 0 && <div className="form-format">
                                    <label className="control-label ">Royalty period</label>
                                    <div className="label-entries">
                                        <select className="form-control " value={manuelInput?.royaltyPeriod ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, royaltyPeriod: e.target.value })}>
                                            <option value="" >Choose a Period</option>
                                            {
                                                periodList?.map((values: any) => {
                                                    return (

                                                        <option value={values?.periodDesc} label={Filter?.SimplemonthAndDayYear(values?.periodFrom) + " - " + Filter?.SimplemonthAndDayYear(values?.periodTo)} className={values?.periodOpen == 2 ? 'text-bold purple' : 'text-bold success'} >

                                                        </option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>}
                            </div>

                            <div className="ws-6">

                                <div className="form-format">
                                    <label className="control-label ws-12">Formats/Source Codes*</label>

                                    <div className="label-entries ws-12">
                                        <button type="button" className="btn noCursor infoText icon-btn info noTransition ">{manuelInput?.mtchFormatCode ?? "Format Code"}</button>
                                        <div className="ws-8 noTransition" >
                                            <select className="noTransition" value={manuelInput?.mtchFormatCode ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, mtchFormatCode: e.target.value })} name="mtchFormatCode" id="mtchFormatCode" required>
                                                <option value="" >Choose Formats/Source Codes</option>
                                                {
                                                    systemFormatsList?.map((values: any) => {
                                                        return (
                                                            <option
                                                                key={values?.codingStr}
                                                                value={values?.codingStr}
                                                                label={`${values?.codingStr} - ${values?.formatDesc ?? ""}`}
                                                            >
                                                                {`${values?.codingStr} - ${values?.formatDesc ?? ""}`}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>

                                        </div>
                                    </div>
                                </div>

                                <div className="form-format hide">
                                    <label className="control-label ">Unique ID </label>
                                    <div className="label-entries "></div>
                                </div>

                                <div className="ws-6">
                                    <div className="form-format">
                                        <label className="control-label ">Home Currency*</label>
                                        <div className="label-entries">
                                            <input type="text" placeholder="Home Curr" value={manuelInput?.homeSign ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, homeSign: e.target.value })} id="homeSign" name="homeSign" readOnly required />
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label ">Retail Price*</label>
                                        <div className="label-entries">
                                            <input type="number" placeholder="Enter Retail Price" className="form-control numberAlign" value={manuelInput?.retailPrice ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, retailPrice: e.target.value })} name="retailPrice" id="retailPrice" required />
                                            {invalidRetailPrice && <div className="help-block alert alert-danger">Retail Price must be numeric</div>}
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label ">Currency Code*</label>
                                        <div className="label-entries">
                                            <input type="text" placeholder="Curr Code" value={manuelInput?.currencySign ?? ""} onClick={() => setcurrency(true)} id="currencySign" name="currencySign" readOnly required />

                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label ">Units Sold*</label>
                                        <div className="label-entries">
                                            <input type="number" placeholder="Enter Units Sold" className="form-control numberAlign" value={manuelInput?.unitsSold ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, unitsSold: e.target.value })} name="unitsSold" id="unitsSold" required />
                                            {invalidRUnitsSold && <div className="help-block  alert alert-danger">Units Sold must be numeric</div>}
                                        </div>
                                    </div>

                                </div>

                                <div className="ws-6">
                                    <div className="form-format">
                                        <label className="control-label ">Home Value*</label>
                                        <div className="label-entries">
                                            <input type="number" placeholder="Home Value" className="form-control numberAlign" value={manuelInput?.monetaryValue ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, monetaryValue: e.target.value, currencyValue: e.target.value })} name="monetaryValue" id="monetaryValue" required />
                                            {invalidHomeValue && <div className="help-block alert alert-danger">Home Value must be numeric</div>}
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label ">Dealer Price*</label>
                                        <div className="label-entries">
                                            <input type="number" placeholder="Dealer Price" className="form-control numberAlign" value={manuelInput?.dealerPrice ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, dealerPrice: e.target.value })} name="dealerPrice" id="dealerPrice" title="This is the DPD, Wholesale or Output Price" required />
                                            {invalidDealerPrice && <div className="help-block alert alert-danger">Dealer Price must be numeric</div>}
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label ">Currency Value*</label>
                                        <div className="label-entries">
                                            <input type="number" placeholder="Curr Value" className="form-control numberAlign" value={manuelInput?.currencyValue ?? ""} name="currencyValue" id="currencyValue" readOnly />
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label ">Hold flag</label>
                                        <label className="label-entries">
                                            <input type="checkbox" className="m0 " value={manuelInput?.holdFlag ?? ""} onChange={(e: any) => setManuelInput({ ...manuelInput, holdFlag: e.target.value })} id="holdFlag" />
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>}

                {!invoiceSelect?.approvalStatus && <div className="box-footer pull-right">
                    <button className="btn icon-btn edit btn-sm " onClick={factSalesActSave}><i className="icon-save"></i> Save</button>
                    <button className="btn icon-btn delete btn-sm " onClick={clearFactSales}><i className="icon-reload"></i> Reset</button>
                </div>}

                <div className="ws-12 box borderRounded">
                    <div className="box-header well">
                        {<h2 className="ws-8  "><i className="fa fa-table"></i> {impHolStreamDetailCount} record(s) found</h2>}

                        <button className="icon-btn info pull-right btn-xs" onClick={invoiceApprove}>
                            <i className={!loadCustomMetadataMain ? "icon-plus icon-plus1" : "icon-minus1"}></i>
                        </button>

                        {!invoiceSelect?.approvalStatus && totalFactSale == invoiceSelect?.homeValue && <>
                            <button className="btn icon-btn info pull-right btn-xs" onClick={() => setApprovedStatus(true)}>
                                <i className="icon-tick"></i> Approve invoice
                            </button>
                        </>}

                    </div>

                    {loadCustomMetadataMain && <div className="box-content ws-12">

                        {factSaleActSuccess && <div className="alert alert-success">Fact sales has been saved successfully.</div>}
                        {factSaleDeleteFlag && <div className="alert alert-info">Fact sales  has been deleted successfully</div>}

                        <div className="ws-12">
                            <div className="form-format ws-6">
                                <label className="control-label">Filter table</label>
                                <div className="label-entries">
                                    <input id="filterTblMFactSales" type="text" className="input-sm" />
                                </div>
                            </div>
                        </div>

                        {impHolStreamDetailCount == 0 && <div className="alert alert-info">No records to display</div>}

                        <div className="ws-12">
                            {impHolStreamDetailCount > 0 && <table className="newTable">
                                <thead>
                                    <tr>
                                        <th >Item Code</th>
                                        <th >Territory</th>
                                        <th >Analysis</th>
                                        <th >Description</th>
                                        <th >Dealer Price</th>
                                        <th >Units Sold</th>
                                        <th >Home Curr</th>
                                        <th >Home Value</th>
                                        {!invoiceSelect?.approvalStatus && <th>Operation</th>}
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        impHolStreamDetailData?.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td >{values?.itemCodeSold}</td>
                                                    <td >{values?.mtchTerritoryCode}</td>
                                                    <td >{values?.mtchAnalysisCode}</td>
                                                    <td >{values?.lineDescription}</td>
                                                    <td >{values?.dealerPrice}</td>
                                                    <td >{values?.unitsSold}</td>
                                                    <td >{values?.homeSign}</td>
                                                    <td >{values?.monetaryValue}</td>
                                                    {!invoiceSelect?.approvalStatus && <td >
                                                        <div className="width140 forceSingleLine">
                                                            <a title="Edit" onClick={() => onInvoiceEdit(values)} className="icon-btn edit"><i className="icon-edit"></i></a>
                                                            <a title="Delete" onClick={() => onInvoiceDelete(values)} className="icon-btn delete"><i className="icon-trashcan"></i></a>
                                                        </div>
                                                    </td>}
                                                </tr>
                                            )
                                        })
                                    }

                                </tbody>
                            </table>}
                        </div>

                        <div className="clearfix">


                        </div>
                    </div>}

                </div>

                {loadCustomMetadataMain && <div className="ws-12 borderRounded mt">

                    <table className="table ws-4">
                        <thead>
                            <tr>
                                <td>&nbsp;</td>
                                <th className="bg-level2">Currency Value</th>
                                <th className="bg-level2">Home Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th className="bg-level2">Header Totals</th>
                                <td className="numberAlign ">{invoiceSelect?.exchRate1 * invoiceSelect?.homeValue}</td>
                                <td className="numberAlign ">{invoiceSelect?.homeValue}</td>
                            </tr>
                            <tr>
                                <th className="bg-level2">File Totals</th>
                                <td className="numberAlign ">{invoiceSelect?.exchRate1 * totalFactSale}</td>
                                <td className="numberAlign ">{totalFactSale}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>}

                {
                    (() => {
                        if (ItemCodeOpen) {
                            return <ItemCodeSearch ItemCodeOpen={ItemCodeOpen} ItemCodeClose={ItemCodeClose} />
                        }

                        if (openTerritory) {
                            return <SearchTerritory open={openTerritory} onSelectTerritory={onSelectTerritory} />
                        }
                        if (deleteStatus) {
                            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected fact sale " + deleteData?.mtchTerritoryCode} onChange={deleteConfirmation} />
                        }

                        if (approvedStatus) {
                            return <DeleteDialogueBox param={approvedStatus} message={"approve this invoice"} onChange={approvedConfirmation} />
                        }

                        if (currency) {
                            return (<SearchCurrency Closecurrency={Closecurrency} open={currency} />)
                        }

                    })()
                }

            </div>
        </>
    )
}